// Ionic & Angular Imports
import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/observable';
import 'rxjs/add/operator/map';

// Providers
import {EquipmentType} from './equipmenttype.service';

export interface Equipment {
    id: number;
    equipment: EquipmentType;
    notes: string;
}

@Injectable()
export class rsEquipmentSvc 
{ 
    constructor(
        public http: Http, 
    ) {
        // Class constructor
    }

    getEquipment(reportId: number) : Observable<Equipment[]> {
        return Observable.create( observer => {

            this.http.get( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/equipment', {
                withCredentials: true
            })
            .map(res => res.json().response.equipment )
            .subscribe( result => {
                observer.next(result);
            }, err => {
                observer.error(err);
            }, () => {
                observer.complete();
            });
        });
    }

    addEquipment( equipmentTypeId : number, notes: string, reportId : number ) : Observable<Equipment> {
        return Observable.create( observer => {
            
            let postData = {
                equipmenttypeid: equipmentTypeId,
                notes: notes
            }

            let body = JSON.stringify(postData);
            let headers = new Headers({
                'Content-Type' : 'application/json'
            });
            let options = new RequestOptions( { headers: headers, withCredentials: true } );
            this.http.post( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/equipment', body, options)
            .map( res => res.json().response.equipment )
            .subscribe( result => {
                observer.next(result);
            }, err => {
                observer.error(err);
            }, () => {
                observer.complete();
            });
        });
    }

    updateEquipment( equipmentId : number, equipmentTypeId : number, notes: string, reportId: number ) : Observable<Equipment> {
        return Observable.create( observer => {

            let patchData = {
                equipmenttypeid: equipmentTypeId,
                notes: notes
            }

            let body = JSON.stringify(patchData);
            let headers = new Headers({
                'Content-Type' : 'application/json'
            });
            let options = new RequestOptions( { headers: headers, withCredentials: true } );
            this.http.patch( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/equipment/' + equipmentId, body, options )
            .map( res => res.json().response.equipment )
                .subscribe( result => {
                    observer.next(result);
                }, err => {
                    observer.error(err);
                }, () => {
                    observer.complete();
                });
        });
    }
    
    deleteEquipment( equipmentId : number, reportId : number ) : Observable<void> {
        return Observable.create( observer => {

            this.http.delete( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/equipment/' + equipmentId, {
                withCredentials: true 
            })
            .map( res => res.json() )
            .subscribe( result => {
                observer.next( result );
            }, err => {
                observer.error(err);
            }, () => {
                observer.complete();
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/equipment.service.ts